module.exports = __webpack_public_path__ + "img/icon_wave_b.b58710df.svg";